import { useState, useEffect } from "react";
import { getLocations } from "../../../utils/services/control/masterDataService";

/**
 * Hook que carga locations clínicas (clinical=true, status=1) desde el API.
 * Retorna un array con { id: locationId, name: medicalCenter }.
 */
let cache = null;

export default function useClinicalLocations() {
  const [locations, setLocations] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    let cancelled = false;

    (async () => {
      try {
        const data = await getLocations({ clinical: true, status: 1 });
        const mapped = (data || []).map((loc) => ({
          id: loc.locationId,
          name: loc.medicalCenter,
        }));
        if (!cancelled) {
          cache = mapped;
          setLocations(mapped);
        }
      } catch (err) {
        console.error("Error loading clinical locations:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return { locations, loading };
}
